import "bootstrap/dist/css/bootstrap.min.css"; // Ensure Bootstrap CSS is included
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Include Bootstrap JS with Popper.js
import './App.css';
import { Routes, Route } from 'react-router-dom';
import MasterLayout from './masterLayout/MasterLayout';
import CarListingStatus from './pages/car-listing-status';
import CarListingDetail from './pages/car-listing-detail';
import CarListingApproved from './pages/car-listing-approved';
import CarListingRejected from './pages/car-listing-rejected';
import CarListingPending from './pages/car-listing-pending';
import CarListingBooked from './pages/car-listing-booked';
import UsersListLayer from './components/UsersListLayer';
import AddUserLayer from './components/AddUserLayer';
import SigninPage from './pages/signin';
import SignupPage from './pages/signup';
import ProtectedRoute from './utils/ProtectedRoute';
import ViewProfileLayer from "./components/ViewProfileLayer";
import DepositeAmount from "./pages/deposite_amount";
import PriceRange from "./pages/price-range";
import { useEffect } from "react";
import { CLIENT_COMPANY } from "./utils/constants";
import Dashboard from "./pages/dashboard";
import BlogsListPage from "./pages/blogs-list";
import AddBlogPage from "./pages/add-blog";
import EditBlogPage from "./pages/edit-blog";

const AppRoutes = () => {

  useEffect(() => {
    document.title = `${CLIENT_COMPANY}`;
  }, []);
  
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/signin"
        element={
          <MasterLayout>
            <SigninPage />
          </MasterLayout>
        }
      />
      <Route
        path="/signup"
        element={
          <MasterLayout>
            <SignupPage />
          </MasterLayout>
        }
      />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <CarListingStatus />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/car-listing-status"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <CarListingStatus />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/car-listing-detail/:id"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <CarListingDetail />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/car-listing-approved"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <CarListingApproved />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/car-listing-rejected"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <CarListingRejected />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/car-listing-pending"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <CarListingPending />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/car-listing-booked"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <CarListingBooked />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/all_constants"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <DepositeAmount />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/price-range"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <PriceRange />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/blogs-list"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <BlogsListPage />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-blog"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <AddBlogPage />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-blog"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <EditBlogPage />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <Dashboard />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/users-list"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <UsersListLayer />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-user"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <AddUserLayer />
            </MasterLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/view-profile"
        element={
          <ProtectedRoute>
            <MasterLayout>
              <ViewProfileLayer />
            </MasterLayout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
